import { Controller } from "@hotwired/stimulus"
let debounce = require("lodash/debounce");

export default class extends Controller {
  static targets = [
    "form",
    "summary", "submitButton",
    "couponInput", "couponButton", "couponInfo",
    "nameInput", "phoneInput", "emailInput", "ageInput", "paymentInput",
    "noteInput"
  ]

  connect() {
    console.log("checkout controller connected");

    this.validate();
    this.validate = debounce(this.validate, 300).bind(this);
  }

  // submitCoupon(e) {
  //   console.log("submitCoupon", this.couponInputTarget.value);
  //   e.preventDefault();

  //   Rails.fetch(`/order/coupon`, { method: "PATCH", body: { coupon: this.couponInputTarget.value } }).then(response => response.text()).then( html => {
  //     this.couponInfoTarget.innerHTML = html;
  //   }).catch(function(error) {
  //     console.error("address lookup error", error);
  //   })
  // }

  changed(e) {
    this.validate();
  }

  validate() {
    if(this.formValid()) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.value = "Complete Order" ;
    } else {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.value = "Enter your details";
    }
  }

  formValid()
  {

    if (this.hasNameInputTarget) {
      if (this.nameInputTarget.value.length < 2) {
        return false;
      }
    }

    if (this.hasEmailInputTarget) {
      if (!this.emailInputTarget.value.includes("@")) {
        return false;
      }
    }

    if (this.hasPhoneInputTarget) {
      if (this.phoneInputTarget.value.length < 5) {
        return false;
      }
    }

    // console.log("notes ", this.hasNoteInputTarget);
    if (this.hasNoteInputTarget) {
      var validNotes = true;
      this.noteInputTargets.forEach(element => {
        // console.log("notes", element.name);
        // console.log("  required", element.required);

        if (element.required && element.value.length < 1) {
          // console.log(element.value + "  valid", false);
          validNotes = false;
        // } else {
          // console.log(element.value +"  valid", true);
        }
      });

      if (!validNotes)
      {
        return false;
      }
    }

    if (this.hasPaymentTarget) {
      var selected = false;
      this.paymentTargets.forEach(element => {
        if (element.checked) {
          selected = true;
        }
      });

      if (!selected)
      {
        return false;
      }
    }

    // console.log("formData: ", this.formTarget.formData);
    return true;
  }

  submitOrderForm(e) {
    var valid = this.formValid();
    console.log("submitOrder valid: ", valid);

    if (valid){
      console.log("valid");
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  }
}
